/*!
 * angular-ui-cgdevtools v1.0.0
 *
 * cg-number
 *
 * Copyright (c) 2013-2014 Pedro Lopes
 *
 */
(function () {
  'use strict';

  angular.module('ui.cgdevtools', [])
    .component('cgNumber', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        name: '@?',
        min: '<?',
        max: '<?',
        step: '<?',
        editable: '<?',
        properties: '<?'
      },
      templateUrl: 'app/components/cgdevtools/cgNumber/cgNumber.html',
      controller: /*@ngInject*/ function ($element, plAlertService) {
        var ctrl = this;
        var defaultOptions = {
          step: 1,
          min: 1,
          max: 2147483647,
          decimalsLimit: 0,
          disabled: false
        };

        ctrl.value = 1;
        ctrl.previousValue = 1;
        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.handleOptions = handleOptions;
        ctrl.render = render;
        ctrl.minus = minus;
        ctrl.plus = plus;
        ctrl.changed = changed;
        ctrl.setValue = setValue;

        /////////////

        function init() {
          $element.addClass('counter-container');
          ctrl.handleOptions();
          ctrl.ngModel.$render = function () {
            var value = ctrl.ngModel.$modelValue;
            var step = ctrl.options.step;
            var min = ctrl.options.min;
            var max = ctrl.options.max;

            if (min && (value < min || value - step < min) || min === 0 && value < 1) {
              value = min;
            } else if (max && (value > max || value + step > max)) {
              value = max;
            }
            ctrl.setValue(value);
          };
        }

        function onChanges(cgNumber) {
          if (cgNumber) {
            ctrl.handleOptions();
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          ctrl.previousValue = ctrl.value;
        }

        function handleOptions() {
          var options = _.merge({}, defaultOptions, ctrl.options, ctrl.properties);

          // Properties
          if (options.step && options.min < options.step) {
            options.min = options.step;
          }
          if (options.step && options.max % options.step !== 0) {
            options.max--;
            while (options.max % options.step) {
              options.max--;
            }
          }

          // Bindings
          if (angular.isDefined(ctrl.step) && ctrl.step !== null && ctrl.step) {
            options.step = ctrl.step;
          }
          if (angular.isDefined(ctrl.min) && ctrl.min !== null && ctrl.min) {
            if (ctrl.step && ctrl.min < ctrl.step) {
              ctrl.min = ctrl.step;
            }
            options.min = ctrl.min;
          }
          if (angular.isDefined(ctrl.max) && ctrl.max !== null && ctrl.max) {
            if (ctrl.step && ctrl.max % ctrl.step !== 0) {
              ctrl.max--;
              while (ctrl.max % ctrl.step) {
                ctrl.max--;
              }
            }
            options.max = ctrl.max;
          }
          if (ctrl.editable === false) {
            options.disabled = true;
          }
          ctrl.options = options;
        }

        function minus() {
          var step = ctrl.options.step;
          var min = ctrl.options.min;
          if (min && (ctrl.value < min || ctrl.value - step < min) || min === 0 && ctrl.value < 1) {
            ctrl.setValue(min);
            plAlertService.error('cgNumber.mensagens.qtdInfMinimaError');
          } else if (ctrl.value % step !== 0) {
            ctrl.setValue(min);
            plAlertService.error('cgNumber.mensagens.qtdNaoMultilpaDe', {'step': step});
          } else {
            ctrl.setValue(ctrl.value - step);
          }
        }

        function plus() {
          var step = ctrl.options.step;
          var max = ctrl.options.max;
          if (max && (ctrl.value > max || ctrl.value + step > max)) {
            ctrl.setValue(max);
            plAlertService.error('cgNumber.mensagens.qtdSupMaximaError');
          } else if (ctrl.value % step !== 0) {
            ctrl.setValue(max);
            plAlertService.error('cgNumber.mensagens.qtdNaoMultilpaDe', {'step': step});
          } else {
            ctrl.setValue(ctrl.value + step);
          }
        }

        function changed() {
          var value = ctrl.value;
          var step = ctrl.options.step;
          var min = ctrl.options.min;
          var max = ctrl.options.max;
          var previousValue = ctrl.previousValue || min || 1;

          // If the user decides to delete the number, we will set it to 0.
          if (isNaN(ctrl.value) || !value) {
            value = previousValue;
          }

          // If a step is set, let's make sure we're within the limit.
          if (step && value % step !== 0) {
            value = previousValue;
            plAlertService.error('cgNumber.mensagens.qtdNaoMultilpaDe', {'step': step});
          }
          // If a minimum is set, let's make sure we're within the limit.
          else if (min && (value < min || value - step < min) || min === 0 && value < 1) {
            value = previousValue;
            plAlertService.error('cgNumber.mensagens.qtdInfMinimaError');
          }
          // If a maximum is set, let's make sure we're within the limit.
          else if (max && (value > max || value + step > max)) {
            value = previousValue;
            plAlertService.error('cgNumber.mensagens.qtdSupMaximaError');
          }

          ctrl.setValue(value);
        }

        function setValue(val) {
          ctrl.value = parseInt(val);
          ctrl.render();
        }
      }
    });
}());
